import {
  Box,
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import React from "react";
import { useStyles } from "./styles";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { useNavigate } from "react-router-dom";
import useAttendance from "../../../Hooks/attendance";
import useCourse from "../../../Hooks/course";
import moment from "moment";
import CustomPagination from "../../../common/Pagination";
import { useState } from "react";
import usePagination from "../../../common/usePagination";
import { useCallback } from "react";
import * as Yup from "yup";
import Loader from "../../../common/Loader";
import useAuthStore from "../../../Hooks/auth";

function isTrue(number) {
  if (Boolean(Number(number)) == "1") {
    return true;
  } else {
    return false;
  }
}
const columns = [
  {
    id: "studentName",
    label: "Student Name",
    align: "center",
    sortby: true,
  },
  {
    id: "idStudent",
    sortby: true,
    label: "Reg Number",
    align: "center",
  },{
    id: "attendanceDate",
    sortby: true,
    label: "Date",
    align: "center",
  },
  {
    id: "departmentName",
    sortby: true,
    label: "Dept",
    align: "center",
  },
  {
    id: "forenoonStatus",
    label: "Fore Noon",
    align: "center",
    sortby: true,
  },
  {
    id: "afternoonStatus",
    label: "After Noon",
    align: "center",
  },
];

const attendanceValidationSchema = Yup.object().shape({
  toDate: Yup.date()
    .when("fromDate", (startDate, schema) => {
      console.log("startDate", startDate, schema);
      if (startDate) {
        const dayAfter = new Date(startDate.getTime());

        return schema.min(
          dayAfter,
          "* Date range looks incorrect"
          // "* The 'To' date cannot be earlier than the 'From' date. Please select a valid date range."
        );
      }

      return schema;
    })
    .required("* date is required")
    .nullable(),
  fromDate: Yup.date()

    .required("* date is required")
    .nullable(),
});

const AttendanceList = () => {
  const classes = useStyles();

  const formRef = React.useRef();
  const [page, setPage] = useState(1);
  const [PerPage, setPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const {institutionId} = useAuthStore()

  // console.log("offset", offset);
  const {
    uploadStudentAttendanceAction,
    downloadTemplateAction,
    resetUrlAction,
    fileUrl,
    getStudentAttendanceAction,
    studentAttendance,
    getCurrentDataAction,
    resetStudentAtttendanceAction,
    loading,
  } = useAttendance();
  const { getDepartmentAction, departmentData } = useCourse();
  const handlePage = (e) => {
    resetPagination();
    setPerPage(e.target.value);
    setTimeout(() => {
      formRef?.current?.handleSubmit();
    }, 100);
  };
  const _DATA = usePagination(studentAttendance?.studentAttendance, PerPage);
  const count =
    studentAttendance &&
    Math.ceil(
      studentAttendance?.totalNoOfRecordsForStudentAttendance
        ?.totalNoOfRecords / PerPage
    );

  // console.log("_DATA", _DATA, count);
  const handleChange = useCallback(
    (e, p) => {
      setPage(p);
      setOffset(p * PerPage - PerPage);
      // _DATA.jump(p);
      setTimeout(() => {
        formRef?.current?.handleSubmit();
      }, 100);
    },
    [PerPage, page]
  );

  const flatListStudentAttendaceData = React.useMemo(() => {
    return _DATA.currentData() || [];
  }, [studentAttendance, page, PerPage]);
  // console.log(
    // "flatListStudentAttendaceData",
    // studentAttendance,
    // PerPage,
    // count,
    // _DATA.currentData(),studentAttendance
    // flatListStudentAttendaceData,
    // _DATA
  // );
  React.useEffect(() => {
    getDepartmentAction({
      department: {
        
        institutionId
      },
    });
  }, []);

  React.useEffect(() => {
    resetStudentAtttendanceAction();
  }, []);
  const navigate = useNavigate();

    // console.log(institutionId,"institutionId")

  const initValues = {
    idDepartment: "",
    year: "",
    fromDate: "",
    toDate: "",
    institutionId
  };


  const handleDownloadFile = async (dataurl, filename) => {
    var arr = dataurl?.split(","),
      bstr = window.atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    let newBlob = new Blob([u8arr]);

    const blobUrl = URL.createObjectURL(newBlob);
    // Create a link element
    const link = document.createElement("a");

    // Set link's href to point to the Blob URL
    link.href = blobUrl;
    link.download = filename;

    // Append link to the body
    document.body.appendChild(link);
    // Dispatch click event on the link
    // This is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );

    // Remove link from body
    document.body.removeChild(link);
    resetUrlAction();
  };

  const resetPagination = useCallback(() => {
    setPerPage(10);
    setPage(1);
    setOffset(0);
  }, []);
  const handleFile = (e) => {
    // get the files
    let file = e.target.files[0];
    const { target = {} } = e || {};

    // Make new FileReader
    let reader = new FileReader();

    // Convert the file to base64 text
    reader.readAsDataURL(file);
    reader.onload = () => {
      const data = reader.result.substr(reader.result.indexOf(",") + 1);
      uploadStudentAttendanceAction(
        {
          base64String:data,
          institutionId:institutionId
        }
        
        
      );
      target.value = "";
    };
  };

  return (
    <>
      {loading && <Loader />}
      <Stack className={classes.arrival}>
        <Grid container>
          <Grid item lg={9} sm={12}>
            <Stack>
              <Grid item md={12} lg={12}>
                <Stack
                  sx={{
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  {/* <Button
                    type="submit"
                    sx={{
                      px: 1,
                      py: 1,
                      borderRadius: "50px",
                      marginBottom: "20px",
                    }}
                    className={classes.add_attendance}
                    onClick={() => navigate("/attendanceList/addAttendance")}
                  >
                    Add Attendance
                  </Button> */}
                  <Button
                    component="label"
                    sx={{
                      px: 1,
                      py: 1,
                      ml: 2,
                      borderRadius: "50px",
                      marginBottom: "20px",
                    }}
                    className={classes.upload_attendance}
                  >
                    Upload Biometric Attendance
                    <input type="file" hidden onChange={(e) => handleFile(e)} />
                  </Button>
                </Stack>
              </Grid>
              <Box sx={{ width: "100%" }}>
                <Paper
                  sx={{
                    width: "100%",
                    borderRadius: "20px",
                    filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                    boxShadow: "none",
                  }}
                >
                  <Stack sx={{ p: 4 }}>
                    <Formik
                      innerRef={formRef}
                      initialValues={initValues}
                      validateOnBlur={false}
                      validationSchema={attendanceValidationSchema}
                      validateOnChange={false}
                      onSubmit={(values) => {
                        downloadTemplateAction(values);
                        getStudentAttendanceAction({
                          fromDate: moment(values.fromDate).format(
                            "YYYY-MM-DD"
                          ),
                          toDate: moment(values.toDate).format("YYYY-MM-DD"),
                          idDepartment: values.idDepartment,
                          limit: PerPage,
                          offset: offset,
                          institutionId: institutionId,
                        });
                      }}
                    >
                      {(formik) => {
                        const {
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          values,
                        } = formik;
                        return (
                          <form
                            onSubmit={(e) => {
                              resetPagination();
                              handleSubmit(e);
                            }}
                          >
                            <Grid
                              container
                              sx={{ py: 2 }}
                              className={classes.form_add_course}
                              spacing={4}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                  gap={1}
                                >
                                  <Stack>
                                    <Typography
                                      className={classes.label}
                                      sx={{ pr: 5.5 }}
                                    >
                                      From
                                    </Typography>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      id="fromDate"
                                      type="date"
                                      name="fromDate"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      className={
                                        errors.fromDate && touched.fromDate
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      value={values.fromDate}
                                      onChange={handleChange}
                                      sx={{
                                        width: 200,
                                      }}
                                      placeholder="Enter From Date"
                                    />
                                    <ErrorMessage
                                      name="fromDate"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack
                                    // style={{
                                    //   paddingRight: "10px",
                                    // }}
                                  >
                                    <Typography className={classes.label}>
                                      To
                                    </Typography>
                                  </Stack>
                                  <Stack
                                    // style={{
                                    //   alignItems: "end",
                                    // }}
                                  >
                                    <TextField
                                      id="toDate"
                                      type="date"
                                      name="toDate"
                                      onChange={handleChange}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      className={
                                        errors.toDate && touched.toDate
                                          ? classes.inputError
                                          : classes.inputNoError
                                      }
                                      value={values.toDate}
                                      sx={{
                                        width: 200,
                                      }}
                                      placeholder="Enter To Date"
                                    />
                                    <ErrorMessage
                                      name="toDate"
                                      component="span"
                                      className={classes.error}
                                    />
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              sx={{ py: 2 }}
                              className={classes.form_add_course}
                              spacing={4}
                            >
                              <Grid item md={6} sx={{ width: "100%" }}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography
                                    className={classes.label}
                                    sx={{ pr: 1 }}
                                  >
                                    Department
                                  </Typography>

                                  <Select
                                    id="idDepartment"
                                    name="idDepartment"
                                    placeholder="Choose idDepartment"
                                    onChange={handleChange}
                                    IconComponent={CustomExpandMore}
                                    sx={{
                                      width: 200,
                                    }}
                                    value={values.idDepartment}
                                    displayEmpty
                                  >
                                    <MenuItem disabled value="">
                                      <span>Select Department</span>
                                    </MenuItem>
                                    {departmentData &&
                                      departmentData?.map((_el, index) => (
                                        <MenuItem value={_el.id} key={index}>
                                          {_el.name}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                  <ErrorMessage
                                    name="idDepartment"
                                    component="span"
                                    className={[
                                      classes.error,
                                      classes.selectError,
                                    ].join(" ")}
                                  />
                                </Stack>
                              </Grid>
                              <Grid item md={6}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <Stack
                                    sx={{
                                      flexDirection: "row",
                                      justifyContent: "flex-end",
                                    }}
                                    gap={2}
                                  >
                                    <Button
                                      type="submit"
                                      sx={{
                                        px: 1,
                                        py: 1,
                                        borderRadius: "50px",
                                      }}
                                      className={classes.add_arrival}
                                    >
                                      Search
                                    </Button>
                                    {/* <Button
                                      type="button"
                                      disabled={
                                        !fileUrl?.length ||
                                        fileUrl === undefined
                                      }
                                      sx={{
                                        px: 1,
                                        py: 1,
                                        borderRadius: "50px",
                                      }}
                                      className={classes.add_arrival}
                                      onClick={() =>
                                        handleDownloadFile(
                                          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
                                            fileUrl,
                                          `year${values.year}-semester${values.idSemester}.xlsx`
                                        )
                                      }
                                    >
                                      Download
                                    </Button> */}
                                  </Stack>
                                </Stack>
                              </Grid>
                            </Grid>
                          </form>
                        );
                      }}
                    </Formik>
                  </Stack>
                </Paper>
              </Box>
            </Stack>

            <Stack sx={{ marginTop: "20px" }}>
              <Box sx={{ width: "100%" }}>
                <Paper
                  sx={{
                    width: "100%",
                    borderRadius: "20px",
                    filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                    boxShadow: "none",
                  }}
                >
                  <Stack sx={{ p: 4 }}>
                    <TableContainer sx={{ maxHeight: 440 }}>
                      <Table
                        aria-label="sticky table"
                        className={classes.root}
                        style={{ padding: 0 }}
                        stickyHeader
                      >
                        <TableHead>
                          <TableRow classes={{ root: classes.thead }}>
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  paddingLeft: column.paddingLeft,
                                }}
                                classes={{ root: classes.columnData }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody classes={{ root: classes.tBody }}>
                          {flatListStudentAttendaceData?.length > 0 ? (
                            flatListStudentAttendaceData?.map((_el, index) => (
                              <TableRow
                                role="checkbox"
                                tabIndex={-1}
                                key={index}
                              >
                                {columns.map((column) => {
                                  const value = _el[column.id];
                                  //console.log("value", value);
                                  return (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {column.id === "select" ? (
                                        <Stack sx={{ alignItems: "center" }}>
                                          <Checkbox defaultChecked />
                                        </Stack>
                                      ) : column.id === "id" ? (
                                        _el.id
                                      ) : column.id === "studentName" ? (
                                        _el.studentName
                                      ) : column.id === "idStudent" ? (
                                        _el.regNumber
                                      ) : column.id === "attendanceDate" ? (
                                        _el.attendanceDate
                                      ): column.id === "departmentName" ? (
                                        _el.departmentName
                                      ) : column.id === "forenoonStatus" ? (
                                        <>
                                          <p
                                            style={{
                                              color:
                                                _el.forenoonStatus === "1"
                                                  ? "green"
                                                  : "red",
                                              cursor: "pointer",
                                            }}
                                            role="button"
                                          >
                                            {_el.forenoonStatus === "1"
                                              ? "Present"
                                              : "Absent"}
                                          </p>
                                        </>
                                      ) : column.id === "afternoonStatus" ? (
                                        <>
                                          <p
                                            style={{
                                              color:
                                                _el.afternoonStatus === "1"
                                                  ? "green"
                                                  : "red",
                                              cursor: "pointer",
                                            }}
                                            role="button"
                                          >
                                            {_el.afternoonStatus === "1"
                                              ? "Present"
                                              : "Absent"}
                                          </p>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={columns.length}
                                sx={{ borderBottom: "none" }}
                              >
                                <Stack
                                  sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data
                                </Stack>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {studentAttendance?.totalNoOfRecordsForStudentAttendance?.totalNoOfRecords > 10 && (
                      <CustomPagination
                        count={count}
                        page={page}
                        onPageChange={handleChange}
                        handlePage={handlePage}
                        perPage={PerPage}
                      />
                    )}
                  </Stack>
                </Paper>
              </Box>
            </Stack>
          </Grid>
          <Grid item lg={4} sm={12}></Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default AttendanceList;
